import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { ROUTES } from '@/lib/constants/routes';
import LanguageSwitcher from '@/components/shared/LanguageSwitcher';

/**
 * AuthLayout - Authentication pages layout
 * 
 * 인증 관련 페이지용 레이아웃
 * - GNB/Footer 없음
 * - 독립적인 레이아웃이 필요한 페이지에 사용
 * - Landing, Login, Signup 등
 * - GNB가 없는 화면에서 UI 언어 전환(우상단). 랜딩(/)은 페이지 내 GNB/푸터와 중복되지 않게 생략
 */
export const AuthLayout: React.FC = () => {
  const { pathname } = useLocation();
  const showLocaleFloating = pathname !== ROUTES.HOME;
  const hasPageGnb = pathname === ROUTES.HOME;

  return (
    <div
      data-page-scroll-container
      className={`relative overflow-y-scroll overscroll-y-contain ${
        hasPageGnb ? 'mt-16 h-[calc(100dvh-4rem)] max-h-[calc(100dvh-4rem)]' : 'h-dvh max-h-dvh'
      }`}
    >
      {showLocaleFloating && (
        <div className="absolute right-4 top-4 z-50 sm:right-6 sm:top-5">
          <LanguageSwitcher variant="labeled" labelType="current" tone="neutral" />
        </div>
      )}
      <Outlet />
    </div>
  );
};
